import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { toast } from 'react-toastify'

import { eventsApi } from '../../../services/events'
import i18n from '../../../i18n'
import { SponsorshipStatus } from '../../../types'
import type { AppStore } from '../../../store'
import type { SubmitSponsorship } from '../../../services/events'

export const submitSponsorship =
  (store: AppStore) =>
  async ({ request, params }: LoaderFunctionArgs) => {
    const data = (await request.json()) as SubmitSponsorship
    const { eventId } = params
    const { t } = i18n

    const result = await store.dispatch(eventsApi.endpoints.submitSponsorship.initiate(data))

    if ('error' in result && result.error) {
      toast.error(t('Erreur lors de la demande de prise en charge'))
      return result
    }

    if ('data' in result && result.data) {
      switch (result.data.status) {
        case SponsorshipStatus.Accepted:
          toast.success(t('Prise en charge acceptée'))
          return redirect(`/events/${eventId}`)
        case SponsorshipStatus.WaitingList:
        case SponsorshipStatus.Pending:
        case SponsorshipStatus.LabSelected:
          toast.success(t('Prise en charge soumise'))
          return redirect(`/events/${eventId}`)
        case SponsorshipStatus.Rejected:
        default:
          toast.error(t('Prise en charge rejetée'))
          break
      }
    }

    return new Response(null, {
      status: 400,
      statusText: 'Failed to submit sponsorship',
    })
  }
